import { apiClient } from "./NetworkService";
// @ts-ignore
import ApiNames from "../constants/ApiNames";
import type { ApiResponse } from "../types/home";
import type {
  UserDetails,
  UploadImageResponse,
  UpdateUserNameResponse,
  UpdateUserGradeResponse,
  UserBookmarksResponse,
  DeleteBookmarksRequest,
  DeleteBookmarksResponse,
  RemoveCourseBookMarksRequest,
  RemoveCourseBookMarksResponse,
} from "../types/user";

const getHeaders = (token?: string) => {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getUser = async (msisdn: string, token?: string): Promise<ApiResponse<UserDetails>> => {
  const res = await apiClient.get(`${ApiNames.user}?msisdn=${msisdn}`, getHeaders(token));
  return res.data;
};

export const uploadImage = async (formData: FormData, token?: string): Promise<ApiResponse<UploadImageResponse>> => {
  const config = getHeaders(token);
  // Do not set Content-Type manually, axios will handle boundary for FormData
  const res = await apiClient.post(ApiNames.uploadImage, formData, config);
  return res.data;
};

export const userName = async (msisdn: string, name: string, token?: string): Promise<ApiResponse<UpdateUserNameResponse>> => {
  const res = await apiClient.get(`${ApiNames.userName}?msisdn=${msisdn}&name=${name}`, getHeaders(token));
  return res.data;
};

export const userGrade = async (msisdn: string, levelId: string, token?: string): Promise<ApiResponse<UpdateUserGradeResponse>> => {
  const res = await apiClient.get(`${ApiNames.userGrade}?msisdn=${msisdn}&levelId=${levelId}`, getHeaders(token));
  return res.data;
};

export const bookMarks = async (subscriberId: string, token?: string): Promise<ApiResponse<UserBookmarksResponse[]>> => {
  const res = await apiClient.get(`${ApiNames.bookMarks}?select=topics&subscriberId=${subscriberId}`, getHeaders(token));
  return res.data;
};

export const deletBookMarks = async (data: FormData, token?: string): Promise<ApiResponse<DeleteBookmarksResponse>> => {
  const config = getHeaders(token);
  const res = await apiClient.post(ApiNames.deletBookMarks, data, config);
  return res.data;
};

export const removeCourseBookMarks = async (data: FormData, token?: string): Promise<ApiResponse<RemoveCourseBookMarksResponse>> => {
  const config = getHeaders(token);
  const res = await apiClient.post(ApiNames.removeCourseBookMarks, data, config);
  return res.data;
};
